export default __webpack_public_path__ + "static/media/Boss-Level.f4d661d1.jpg";